module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAALCAYAAABLcGxfAAAAAXNSR0IArs4c6QAAAUBJREFUKFONkDFLA0EQhd/MHvE4Wxt7QQQLEQSb2PgPhDRmE4JIIEIauxR2FnZWoiRIcrdLwDoWgpWVELQULRTbVAEbo2S50QuJJCrowhTLfG/mzaN8Pr+tlKr1+/0da+0xhk9rPU9ENyLyHARBulqtviQtSkprfcrMm8y81Gg0HorFYtDr9c4BLIhI2lr7OBqUCKC1niWiCwDKGLOotS4x86Fzbq3ZbLZH8GjD4J/NZleZ+QpAKCIbAHattdE4PBBkMhnl+36y+o2IKp7nbTnnLpm5kgDdbve+1Wq9flnK5XLTRHQEYAaAD2BdRO4+nSa+A2YuhWH4NHFDuVye6nQ6LpVKrXiedx3H8Z4xZr9QKPj1ev2diGRCMBblslLqNo7jijHm4Lv/iaOHac0BOGHmWhRFZ38KfgN+pPQfaJz5ADXbbwwLo0XzAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/￥.png
// module id = gKww
// module chunks = 128